import {Locales} from '@netx/core-locales/utils/Locales';
import {
	UserLevel,
	UserGroupItemType,
	UserImportOption,
	EmailFrequency,
} from './constants';

export const GroupLabel = Locales((i18n) => ({
	ADD_GROUP: i18n('i18n.addGroup'),
	SELECT_GROUP: i18n('i18n.selectGroup'),
}));

export const UserLevelLabel = Locales<Record<UserLevel, string>>((i18n) => ({
	[UserLevel.ADMIN]: i18n('i18n.userLevel9'),
	[UserLevel.BROWSER]: i18n('i18n.userLevel1'),
	[UserLevel.CONSUMER]: i18n('i18n.userLevel2'),
	[UserLevel.DIRECTOR]: i18n('i18n.userLevel8'),
	[UserLevel.IMPORTER]: i18n('i18n.userLevel3'),
	[UserLevel.MANAGER]: i18n('i18n.userLevel7'),
	[UserLevel.PRODUCER]: i18n('i18n.userLevel4'),
}));

export const USER_LEVEL_LABEL = UserLevelLabel;

export const USER_GROUP_ITEM_TYPE_LABEL = Locales((i18n) => ({
	[UserGroupItemType.GROUP]: i18n('i18n.group'),
	[UserGroupItemType.USER]: i18n('i18n.user'),
}));

export const USER_SELECTOR_ACTION_LABEL = Locales((i18n) => ({
	CLEAR: i18n('i18n.clear'),
}));

export const UserSelectorLabel = Locales((i18n) => ({
	ALL_USERS: i18n('i18n.allUsers'),
	NO_USERS_SELECTED: i18n('i18n.emptyUsersList'),
	SELECT_GROUPS: i18n('i18n.addGroups'),
	SELECT_USERS: i18n('i18n.addUsers'),
	SELECT_GROUPS_USERS: i18n('i18n.addUsersOrGroups'),
	ALL: i18n('i18n.everyone'),
	ADD_USER: i18n('i18n.addUser'),
	SELECT_USER: i18n('i18n.selectUser'),
}));

export const USER_SELECTOR_LABEL = UserSelectorLabel;

export const UserDialogTitle = Locales((i18n) => ({
	CONFIRMATION_TITLE: i18n('i18n.resetUserPasswordConfirmTitle'),
}));

export const UserActionLabel = Locales((i18n) => ({
	ATTRIBUTE_SETS: i18n('i18n.attributeSets'),
	GROUPS: i18n('i18n.groups'),
	INTEGRATIONS: i18n('i18n.integrations'),
	LOGIN: i18n('i18n.signIn'),
	LOGIN_AS: i18n('i18n.loginAsThisUser'),
	LOGOUT: i18n('i18n.signOut'),
	NOTIFICATIONS: i18n('i18n.emailSettings'),
	PERMISSIONS: i18n('i18n.permissions'),
	PROFILE: i18n('i18n.profile'),
	RESET_PASSWORD: i18n('i18n.resetPassword'),
	SETTINGS: i18n('i18n.settings'),
	USERS: i18n('i18n.users'),
	HELP: i18n('i18n.help'),
}));

export const UserMessage = Locales((i18n) => ({
	PASSWORD_RESET_EMAIL_SUCCESS: i18n('i18n.resetPasswordEmailSent'),
	PASSWORD_RESET_EMAIL_ERROR: i18n('i18n.couldNotSendPasswordResetEmail'),
	NO_SPACES: i18n('i18n.noSpacesAllowed'),
	RESET_PASSWORD_MESSAGE: i18n('i18n.confirmResetYourPassword'),
}));

export const UserImportOptionLabel = Locales((i18n) => ({
	[UserImportOption.ADD_AND_UPDATE]: i18n('i18n.addAndUpdate'),
	[UserImportOption.ADD_NEW_USERS_ONLY]: i18n('i18n.addOnlyNewUsers'),
	[UserImportOption.DELETE]: i18n('i18n.delete'),
	[UserImportOption.UPDATE_EXISTING_USERS_ONLY]: i18n(
		'i18n.updateOnlyExistingUsers',
	),
}));

export const UserRestrictionLabel = Locales<Record<UserLevel, string>>(
	(i18n) => ({
		[UserLevel.BROWSER]: USER_LEVEL_LABEL[UserLevel.BROWSER],
		[UserLevel.CONSUMER]: USER_LEVEL_LABEL[UserLevel.CONSUMER],
		[UserLevel.IMPORTER]: USER_LEVEL_LABEL[UserLevel.IMPORTER],
		[UserLevel.PRODUCER]: USER_LEVEL_LABEL[UserLevel.PRODUCER],
		[UserLevel.MANAGER]: USER_LEVEL_LABEL[UserLevel.MANAGER],
		[UserLevel.DIRECTOR]: USER_LEVEL_LABEL[UserLevel.DIRECTOR],
		[UserLevel.ADMIN]: USER_LEVEL_LABEL[UserLevel.ADMIN],
	}),
);

export const NotificationsTitle = Locales((i18n) => ({
	NOTIFICATIONS: i18n('i18n.emailSettings'),
}));

export const NotificationsSettingsTitle = Locales((i18n) => ({
	IMPORT: i18n('i18n.emailDeliveryImport_title'),
	REVIEW: i18n('i18n.emailDeliveryReview_title'),
}));

export const NotificationsSettingsDescription = Locales((i18n) => ({
	IMPORT: i18n('i18n.emailDeliveryImport_description'),
	REVIEW: i18n('i18n.emailDeliveryReview_description'),
}));

export const NotificationsMenuLabel = Locales((i18n) => ({
	[EmailFrequency.IMMEDIATE]: i18n('i18n.emailDeliveryInstantly_title'),
	[EmailFrequency.DAILY]: i18n('i18n.emailDeliveryDaily_title'),
	[EmailFrequency.NEVER]: i18n('i18n.emailDeliveryNever_title'),
}));

export const NotificationsMenuDescription = Locales((i18n) => ({
	[EmailFrequency.IMMEDIATE]: i18n('i18n.emailDeliveryInstantly_description'),
	[EmailFrequency.DAILY]: i18n('i18n.emailDeliveryDaily_description'),
	[EmailFrequency.NEVER]: i18n('i18n.emailDeliveryNever_description'),
}));

export const NotificationsMenuActionLabel = Locales((i18n) => ({
	CANCEL: i18n('i18n.cancel'),
	SAVE: i18n('i18n.save'),
}));
